import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
window.Yext = window.Yext || {};
import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js'; /* TODO: remove if unused */
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js'; /* TODO: remove if unused */

Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
  const uri = new URL(window.location.href);
  const data = { pagePath: uri.pathname.toLowerCase().replaceAll('/', ':').replaceAll('-', ' ') };

  window.addEventListener(
    "message",
    (event) => {
      if (
        event.origin !==
          "https://embed-answers_nationwide_co_uk.yextpages.net" &&
        event.origin !== "https://embed-answers.nationwide.co.uk.pagescdn.com"
      ) {
        return;
      } else {
        if (event.data === "Iframe loaded") {
          const iframe = document.getElementById("answers-frame");
          if (iframe) {
            try {
              iframe.contentWindow.postMessage(data, "https://embed-answers_nationwide_co_uk.yextpages.net");
            } catch(err) {}
            try {
              iframe.contentWindow.postMessage(data, "https://embed-answers.nationwide.co.uk.pagescdn.com");
            } catch(err) {}
          } else {
            console.error("Could not find iframe with ID 'answers-frame'.");
          }
        }
      }
    }
  );
});
